class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static reinitHorizontalFilters() {
    // Reinitialize horizontal filter disclosures after AJAX content update
    document.querySelectorAll("horizontal-filter-disclosure").forEach((el) => {
      if (typeof el.reinit === "function") {
        el.reinit();
      }
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById("ProductCountDesktop");

    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection-grid-container")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (document.getElementById("SortBy")) {
          document.getElementById("SortBy").dispatchEvent(new Event("change", { bubbles: true }));
        }
        if (typeof initializeScrollAnimationTrigger === "function") initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (document.getElementById("SortBy")) {
      document.getElementById("SortBy").dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (typeof initializeScrollAnimationTrigger === "function") initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, "text/html").getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    // Query all filter forms (drawer, horizontal, sidebar) using class selector
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll("facet-filters-form .js-filter");
    const facetDetailsElementsFromDom = document.querySelectorAll("facet-filters-form .js-filter");

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        /*
        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
        */
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.reinitHorizontalFilters();

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter"));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementToActivate = newFacetDetailsElement.querySelector(".facets__summary");

        const isTextInput = event.target.getAttribute("type") === "text";

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    // Update drawer/sidebar active facets (not horizontal - those have additional class)
    const drawerActiveFacets = html.querySelector(".active-facets:not(.active-facets--horizontal)");
    const drawerActiveFacetsDom = document.querySelector(".active-facets:not(.active-facets--horizontal)");
    if (drawerActiveFacets && drawerActiveFacetsDom) {
      drawerActiveFacetsDom.innerHTML = drawerActiveFacets.innerHTML;
    }

    // Update horizontal active facets wrapper (includes conditional rendering)
    const horizontalActiveFacetsWrapper = html.querySelector(".facets-horizontal__active-facets");
    const horizontalActiveFacetsWrapperDom = document.querySelector(".facets-horizontal__active-facets");
    if (horizontalActiveFacetsWrapper && horizontalActiveFacetsWrapperDom) {
      horizontalActiveFacetsWrapperDom.innerHTML = horizontalActiveFacetsWrapper.innerHTML;
    }

    // Update the horizontal selected counts in filter buttons
    const horizontalCountsFromFetch = html.querySelectorAll(".facets-horizontal__selected-count");
    const horizontalCountsFromDom = document.querySelectorAll(".facets-horizontal__selected-count");
    horizontalCountsFromDom.forEach((domEl, index) => {
      const fetchedEl = horizontalCountsFromFetch[index];
      if (fetchedEl) {
        domEl.textContent = fetchedEl.textContent;
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector("show-more-button .label-show-more.hidden"));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) => hiddenItem.classList.replace("hidden", "show-more-item"));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id
      }
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    // console.log(new URLSearchParams(formData).toString());
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const params = new URLSearchParams();

    const currentUrl = new URL(window.location.href);
    const sortParam = currentUrl.searchParams.get("sort_by");
    if (sortParam) {
      params.set("sort_by", sortParam);
    }

    const sortBySelect = document.getElementById("SortBy");
    if (sortBySelect && sortBySelect.value) {
      params.set("sort_by", sortBySelect.value);
    }

    // Get the form that triggered this event - use it as source of truth
    const sourceForm = event.target.closest("form");

    // Sync checkbox states from source form to other forms before collecting params
    // This prevents race conditions where forms have different states
    if (sourceForm) {
      const sourceCheckboxes = sourceForm.querySelectorAll('input[type="checkbox"]');
      sourceCheckboxes.forEach((sourceInput) => {
        if (sourceInput.name && sourceInput.value) {
          // Find matching checkboxes in other forms by name and value
          // Use CSS.escape to handle special characters in attribute values
          const escapedName = CSS.escape(sourceInput.name);
          const escapedValue = CSS.escape(sourceInput.value);
          const selector = `input[type="checkbox"][name="${escapedName}"][value="${escapedValue}"]`;
          document.querySelectorAll(selector).forEach((otherInput) => {
            if (otherInput !== sourceInput) {
              otherInput.checked = sourceInput.checked;
            }
          });
        }
      });
    }

    const sortFilterForms = document.querySelectorAll("facet-filters-form form");

    // Check if horizontal price filter inputs are visible (desktop inline filters)
    // Use offsetParent to check visibility - hidden elements have null offsetParent
    const horizontalPriceEl = document.querySelector("[data-price-range-inputs]");
    const horizontalPriceInputs = horizontalPriceEl && horizontalPriceEl.offsetParent !== null ? horizontalPriceEl : null;

    // Track which checkbox values have been added to avoid duplicates from multiple forms
    const addedCheckboxValues = new Set();

    sortFilterForms.forEach((form) => {
      const checkboxInputs = form.querySelectorAll('input[type="checkbox"]');
      checkboxInputs.forEach((input) => {
        if (input.checked && input.name) {
          // Create unique key combining name and value to handle multi-value filters
          const key = `${input.name}=${input.value}`;
          if (!addedCheckboxValues.has(key)) {
            params.append(input.name, input.value);
            addedCheckboxValues.add(key);
          }
        }
      });

      const otherInputs = form.querySelectorAll('input:not([type="checkbox"])');
      otherInputs.forEach((input) => {
        if (input.value && input.name !== "sort_by") {
          // Skip drawer price inputs when horizontal price inputs exist
          const isPriceInput = input.name.includes("filter.v.price");
          const isInHorizontalFilter = input.closest("[data-price-range-inputs]") !== null;

          if (isPriceInput && horizontalPriceInputs && !isInHorizontalFilter) {
            return; // Skip drawer form's price inputs
          }

          params.set(input.name, input.value);
        }
      });

      const selectElements = form.querySelectorAll("select");
      selectElements.forEach((select) => {
        if (select.value && select.name === "sort_by") {
          params.set("sort_by", select.value);
        }
      });
    });

    this.onSubmitForm(params.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this));
      element.addEventListener("keydown", this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    const allowedKeys = [
      "Backspace",
      "Tab",
      "Enter",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Escape"
    ];
    if (!allowedKeys.includes(event.key) && !/[0-9.,]/.test(event.key)) {
      event.preventDefault();
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (maxInput.value) {
      minInput.setAttribute("data-max", maxInput.value);
    } else {
      minInput.setAttribute("data-max", maxInput.getAttribute("max"));
    }

    if (minInput.value) {
      maxInput.setAttribute("data-min", minInput.value);
    } else {
      maxInput.setAttribute("data-min", minInput.getAttribute("min"));
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min")) || 0; // Default to input's min attribute
    const max = Number(input.getAttribute("max")); // Default to input's max attribute

    if (!isNaN(min) && value < min) input.value = min;
    if (!isNaN(max) && value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
